import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Toaster } from '../components/ui/sonner';
import { toast } from 'sonner';
import { Loader2, Mail, ArrowLeft } from 'lucide-react';
import CaptchaWidget from '../components/CaptchaWidget';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, {
        email,
        captcha_token: captchaToken,
      });
      setSent(true);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al enviar el email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <div className="noise-overlay" />
      <div className="w-full max-w-md relative z-10" data-testid="forgot-password-page">
        <div className="flex items-center justify-center gap-3 mb-8">
          <img src="/logo-ar.png" alt="AR Performance" className="w-10 h-10 object-contain" />
          <span className="font-heading text-xl font-bold text-white">AR PERFORMANCE</span>
        </div>

        {sent ? (
          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
              <Mail className="w-8 h-8 text-primary" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-white">EMAIL ENVIADO</h1>
            <p className="text-zinc-400">
              Si el email existe en nuestro sistema, recibirás un enlace para restablecer tu contraseña.
            </p>
            <Link to="/login">
              <Button variant="outline" className="mt-4 border-white/20 text-white hover:bg-white/10">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Volver al login
              </Button>
            </Link>
          </div>
        ) : (
          <>
            <div className="text-center mb-8">
              <h1 className="font-heading text-3xl font-bold text-white mb-2">RECUPERAR CONTRASEÑA</h1>
              <p className="text-zinc-400">Introduce tu email para recibir un enlace de recuperación</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-zinc-300">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@email.com"
                  required
                  className="bg-surface-highlight border-white/10 text-white placeholder:text-zinc-600 h-12"
                  data-testid="forgot-email-input"
                />
              </div>

              <CaptchaWidget onVerify={setCaptchaToken} />

              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-primary hover:bg-primary/90 text-white font-heading uppercase tracking-wider h-12"
                data-testid="forgot-submit-btn"
              >
                {loading ? (
                  <><Loader2 className="w-5 h-5 mr-2 animate-spin" /> Enviando...</>
                ) : (
                  'Enviar Enlace'
                )}
              </Button>
            </form>

            <div className="mt-6 text-center">
              <Link to="/login" className="text-zinc-500 hover:text-white text-sm">
                <ArrowLeft className="w-4 h-4 inline mr-1" />
                Volver al login
              </Link>
            </div>
          </>
        )}
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default ForgotPasswordPage;
